export const USER_SSO_STATE_KEY_BASE = 'user_sso_state';
export const UserSsoStateKeyFactory = {
    all: () => [USER_SSO_STATE_KEY_BASE],
    byEmail: (email) => [...UserSsoStateKeyFactory.all(), email],
};
